module.exports = __webpack_public_path__ + "static/img/img-main-features-setcion-2@2x.5f3ae71.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/img-main-features-setcion-2@2x.png
// module id = /j7I
// module chunks = 18